// GENERATED FILE - DO NOT MODIFY

export enum UserAccountStatusDto {
    Pending = "Pending",
    Active = "Active",
    Deactivated = "Deactivated",
}